import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useEffect, useState, useRef } from "react";
import Stack from "@mui/material/Stack";
import { styled } from "@mui/material/styles";
import * as z from "zod"
import { BannerComponent } from "./Banners/newBanner/BannerComponent.js";
import { Button, Typography } from "../../../ui";
import { LoadingButton } from "@mui/lab";
import { SelectOptions } from "./Banners/SelectOptions";
import { SELECT_OPTIONS } from "./Banners/configs";
import { useFormik } from "formik";
import SendIcon from "@mui/icons-material/Send";
import * as Yup from "yup";
// import "./Banners/myBanners.scss"
import { DOMAIN_API_HOST } from "../../../configs/main"
import { useSnackbar } from "notistack";
import useAdminUser from "../../../data/useAdminUser";
import { getDomainConfig } from "../../../configs/main";
import { trackWizardEvent } from "../../../utils/productEvents";

import {
  FormControl,
  FormHelperText,
  TextField,
  useMediaQuery,
} from "@mui/material";
import { BuildTwoTone } from '@mui/icons-material';





const InitialValues = {
  retargeting: {
    ya_metrika_goals: [],
    retarget_all_visitors: false,
    using_programmatic: false,
    using_retargeo: true,
    using_rsya: false,
  },
  retargetingGoals: {
    platform: "",
    googleAnalytics: "",
    crmSystem: "",
  },
  placementFrequency: {
    frequency: "-1",
    customValueFrequency: "",
    intervalMinutes: "60",
    customValueIntervalMinutes: "",
  },
  sspUsage: {
    programmatic: true,
    retargeo: true,
    rsy: false,
  },
  budgetDistribution: {
    retargeting: 90,
    lookAlike: 10,
  },
  dynamicRetargeting: {
    enabled: false,
    platform: "ya_metrika",
    selectedGoal: "all",
    banners: [],
    triggerName: "",
    exclusions: [],
  },
}

export const RetargetingPage = ({
  campaignID,
  currentAdId,
  changeTab,
  disable,
  upd,
  setUpd,
  updBanner,
  setUpdBanner,
  setHasUnsavedChanges,
  saveFormRef,
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [banners, setBanners] = useState([])
  const [data, setData] = useState(InitialValues)
  const [metricaGoals, setMetricaGoals] = useState([])
  const [ads, setAds] = useState([])
  const [openDropdown, setOpenDropdown] = useState(null)
  const [isMetricaDropdownOpen, setIsMetricaDropdownOpen] = useState(false)
  const [isAdsDropdownOpen, setIsAdsDropdownOpen] = useState(false)
  const [isExclusionsDropdownOpen, setIsExclusionsDropdownOpen] = useState(false)
  const [savedTriggers, setSavedTriggers] = useState([])
  const [editingTriggerId, setEditingTriggerId] = useState(null)
  const { enqueueSnackbar } = useSnackbar();
  const debounceTimers = useRef({});
  const updateQueues = useRef({});
  const isUpdating = useRef({});
  const [update, setUpdate] = useState(false)
  const [updateTriggers, setUpdateTriggers] = useState(false)
  const [usersStats, setUsersStats] = useState({
    users: "",
    newUsersPercentage: "",
  })

  useEffect(() => {
    const fetchData = async () => {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(
        "Authorization",
        "Bearer " + localStorage.getItem("token")
      )
      const response = await fetch(`${DOMAIN_API_HOST}/api/v1/campaigns/${campaignID}/?upd=true`, {
        method: "GET",
        headers: myHeaders,
      });
      if (response.ok) {
        const data = await response.json();
        if (data.retargeting) {
          setData({
            ...InitialValues,
            retargeting: {
              ...InitialValues.retargeting,
              ...data.retargeting,
              ya_metrika_goals: (data.retargeting.ya_metrika_goals || []).map(String),
            },
            dynamicRetargeting: {
              ...InitialValues.dynamicRetargeting,
              enabled: data.retargeting.dynamic_retargeting,
            }
          })
          if ([-1, 1, 4, 8, 16, 32].includes(data.retargeting.frequency_of_views)) {
            setData((prev) => {
              return {
                ...prev,
                placementFrequency: {
                  ...prev.placementFrequency,
                  frequency: data.retargeting.frequency_of_views,
                },
              }
            })
          } else {
            setData((prev) => {
              return {
                ...prev,
                placementFrequency: {
                  ...prev.placementFrequency,
                  frequency: "custom",
                  customValueFrequency: data.retargeting.frequency_of_views
                },
              }
            })
          }
          if ([5, 15, 30, 60, 120].includes(data.retargeting.interval_of_views)) {
            setData((prev) => {
              return {
                ...prev,
                placementFrequency: {
                  ...prev.placementFrequency,
                  intervalMinutes: data.retargeting.interval_of_views,
                },
              }
            })
          } else {
            setData((prev) => {
              return {
                ...prev,
                placementFrequency: {
                  ...prev.placementFrequency,
                  intervalMinutes: "custom",
                  customValueIntervalMinutes: data.retargeting.interval_of_views
                },
              }
            })
          }
          if (data.retargeting.distribution || data.retargeting.look_a_like) {
            setData((prev) => {
              return {
                ...prev,
                budgetDistribution: {
                  ...prev.budgetDistribution,
                  retargeting: data.retargeting.distribution,
                  lookAlike: data.retargeting.look_a_like
                },
              }
            })
          }
        }
        // setData(data)
      }
      const responseGoals = await fetch(`${DOMAIN_API_HOST}/api/v1/campaigns/goals?campaign_id=${campaignID}`, {
        method: "GET",
        headers: myHeaders,
      });
      if (responseGoals.ok) {
        const data = await responseGoals.json();
        setMetricaGoals(data)
      }

      const responseAds = await fetch(`${DOMAIN_API_HOST}/api/v1/advertisements/fetch?campaign_id=${campaignID}`, {
        method: "GET",
        headers: myHeaders,
      });
      if (responseAds.ok) {
        const data = await responseAds.json();
        const sortedAds = data.sort(
          (a, b) => new Date(b.created_at) - new Date(a.created_at)
        );
        setAds(sortedAds)
      }
    }
    fetchData()
  }, [update])

  useEffect(() => {
    const goals = data.retargeting.ya_metrika_goals || []
    if (goals.length === 0 || typeof goals[0] !== "number") return
    setData((prev) => ({
      ...prev,
      retargeting: {
        ...prev.retargeting,
        ya_metrika_goals: (prev.retargeting.ya_metrika_goals || []).map(String),
      },
    }))
  }, [data.retargeting.ya_metrika_goals])

  useEffect(() => {
    const fetchData = async () => {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(
        "Authorization",
        "Bearer " + localStorage.getItem("token")
      )
      const response = await fetch(`${DOMAIN_API_HOST}/api/v1/campaigns/users?campaign_id=${campaignID}`, {
        method: "GET",
        headers: myHeaders,
      });
      if (response.ok) {
        const data = await response.json();
        setUsersStats({
          users: data.stats_data[0],
          newUsersPercentage: (data.stats_data[1]).toFixed(2),
        })
      }
    } 
    fetchData()
  }, [])


  useEffect(() => {
    const fetchData = async () => {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(
        "Authorization",
        "Bearer " + localStorage.getItem("token")
      )
      const response = await fetch(`${DOMAIN_API_HOST}/api/v1/campaigns/triggers?campaign_id=${campaignID}`, {
        method: "GET",
        headers: myHeaders,
      });
      if (response.ok) {
        const data = await response.json();
        const triggersMap = data.map((trigger) => ({
          id: trigger.id,
          name: trigger.display_name,
          enabled: trigger.enabled,
          platform: "ya_metrika",
          selectedGoal: trigger.goal_id.toString(),
          banners: trigger.advertisement_ids,
          exclusions: (trigger.excluded_goal_ids || []).map((g) => g),
        }))
        setSavedTriggers(triggersMap)

        console.log("triggers", data, triggersMap)
      }
    }
    fetchData()
  }, [updateTriggers])

  const debounceUpdate = (field, callback, delay = 500) => {
    const uniqueKey = `${field}`;
    clearTimeout(debounceTimers.current[uniqueKey]);

    debounceTimers.current[uniqueKey] = setTimeout(() => {
        if (!updateQueues.current[uniqueKey]) updateQueues.current[uniqueKey] = [];
        updateQueues.current[uniqueKey].push(callback);
        processUpdateQueue(uniqueKey);
    }, delay);
  };

  const processUpdateQueue = async (uniqueKey) => {
      if (isUpdating.current[uniqueKey] || !updateQueues.current[uniqueKey] || updateQueues.current[uniqueKey].length === 0) return;

      isUpdating.current[uniqueKey] = true;

      while (updateQueues.current[uniqueKey].length > 0) {
          const callback = updateQueues.current[uniqueKey].shift();
          await callback();
      }

      isUpdating.current[uniqueKey] = false;
  };

  const handleChange = (field, value, delay) => {
    console.log(field, value);
      debounceUpdate(field, async () => {
          await updateFields({ [field]: value });
      }, delay);
  };

  const updateFields = async (fields) => {
      console.debug("fields", fields);
      if (!Object.values(fields).some((value) => value !== "")) return;
      await fetch(`${DOMAIN_API_HOST}/api/v1/campaigns/${campaignID}/?upd=true`, {
          method: "PUT",
          headers: {
              "Content-Type": "application/json",
              "Authorization": `Bearer ${localStorage.getItem("token")}`,
          },
          body: JSON.stringify({
            retargeting: fields
          }),
      });
      setUpdate((prev) => !prev)
  };


  const handleInputChange = (section, field, value) => {
    if (section === "dynamicRetargeting" && field === "selectedGoal") {
      setData((prev) => {
        const filteredExclusions =
          value === "all"
            ? prev.dynamicRetargeting.exclusions
            : prev.dynamicRetargeting.exclusions.filter((g) => String(g) !== String(value))
        return {
          ...prev,
          dynamicRetargeting: {
            ...prev.dynamicRetargeting,
            selectedGoal: value,
            exclusions: filteredExclusions,
          },
        }
      })
    } else {
      setData((prev) => ({
        ...prev,
        [section]: {
          ...prev[section],
          [field]: value,
        },
      }))
    }
    if (field === "frequency") {
      if (value === "custom") return;
      return handleChange("frequency_of_views", value)
    }
    if (field === "intervalMinutes") {
      if (value === "custom") return;
      return handleChange("interval_of_views", value)
    }
    if (field === "customValueFrequency") {
      return handleChange("frequency_of_views", value, 1200)
    }
    if (field === "customValueIntervalMinutes") {
      return handleChange("interval_of_views", value, 1200)
    }

    if (field === "ya_metrika_goals") {
      return handleChange("ya_metrika_goals", value, 1800)
    }

    if (field === "retarget_all_visitors") {
      return handleChange("retarget_all_visitors", value, 500)
    }

    if (section !== "dynamicRetargeting") {
      return handleChange(field, value)
    }
    
    if (setHasUnsavedChanges) {
      setHasUnsavedChanges(true)
    }
  }

  const handleSspToggle = (platform) => {
    setData((prev) => ({
      ...prev,
      retargeting: {
        ...prev.retargeting,
        [platform]: !prev.retargeting[platform],
      },
    }))
    handleChange(platform, !data.retargeting[platform])
    if (setHasUnsavedChanges) {
      setHasUnsavedChanges(true)
    }
  }

  const handleBudgetChange = (type, value) => {
    const numValue = Number.parseInt(value)
    const otherType = type === "retargeting" ? "lookAlike" : "retargeting"
    const otherValue = 100 - numValue

    setData((prev) => ({
      ...prev,
      budgetDistribution: {
        [type]: numValue,
        [otherType]: otherValue,
      },
    }))
    
    if (setHasUnsavedChanges) {
      setHasUnsavedChanges(true)
    }
  }

  const handleSaveBudgetDistribution = () => {
    handleChange("distribution", data.budgetDistribution.retargeting)
    handleChange("look_a_like", data.budgetDistribution.lookAlike)

    enqueueSnackbar("Данные сохранены", { variant: "success" })
  }

  const handleTriggerToggle = (id) => {
    setSavedTriggers((prev) => {
      if (disable) {
        enqueueSnackbar("Необходимо обновить дату окончания работы кампании.", { variant: "info" })
        return prev
      }
      // const alreadyEnabled = prev.some((trigger) => trigger.enabled);
      // if (alreadyEnabled && !prev.some((trigger) => trigger.id === id && trigger.enabled)) {
      //   enqueueSnackbar("Одновременно может быть запущен только один триггер.", {variant:"info",autoHideDuration: 2000,})
      //   return prev;
      // }
      return prev.map((trigger) => (trigger.id === id ? { ...trigger, enabled: !trigger.enabled } : trigger))
    })
    updateTrigger(id, { enabled: !savedTriggers.find((trigger) => trigger.id === id).enabled }, true)
    if (setHasUnsavedChanges) {
      setHasUnsavedChanges(true)
    }
  }

  const handleDynamicRetargetingToggle = () => {
    setData((prev) => ({
      ...prev,
      dynamicRetargeting: {
        ...prev.dynamicRetargeting,
        enabled: !prev.dynamicRetargeting.enabled,
      },
    }))
    handleChange("dynamic_retargeting", !data.dynamicRetargeting.enabled, 1500)
    setSavedTriggers((prev) => prev.map((trigger) => ({ ...trigger, enabled: false })))
    if (data.dynamicRetargeting.enabled) {
      setEditingTriggerId(null)
      setData((prev) => ({
        ...prev,
        dynamicRetargeting: {
          ...InitialValues.dynamicRetargeting,
          enabled: false,
        },
      }))
    }
    if (setHasUnsavedChanges) {
      setHasUnsavedChanges(true)
    }
  }

  const createTrigger = async (triggerData) => {
    const headers = {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem("token")}`,
    };
    const response = await fetch(`${DOMAIN_API_HOST}/api/v1/campaigns/triggers/create?campaign_id=${campaignID}`, {
      method: "POST",
      headers,
      body: JSON.stringify({
        display_name: triggerData.name,
        advertisement_ids: triggerData.banners,
        platform: triggerData.platform,
        goal_id: Number(triggerData.selectedGoal),
        excluded_goal_ids: triggerData.exclusions || [],
      }),
    });
    return response.ok
  }

  const updateTrigger = async (triggerId, triggerData, toggle) => {
    const headers = {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem("token")}`,
    };
    let data = {
      enabled: triggerData.enabled,
      display_name: triggerData.name,
      advertisement_ids: triggerData.banners,
      platform: triggerData.platform,
      goal_id: Number(triggerData.selectedGoal),
      excluded_goal_ids: triggerData.exclusions || [],
    }
    if (toggle) {
      data = {
        enabled: triggerData.enabled,
      }
    }
    const response = await fetch(`${DOMAIN_API_HOST}/api/v1/campaigns/triggers/update?_id=${triggerId}`, {
      method: "POST",
      headers,
      body: JSON.stringify(data),
    });
    return response.ok
  }

  const deleteTrigger = async (triggerId) => {
    const headers = {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem("token")}`,
    };
    const response = await fetch(`${DOMAIN_API_HOST}/api/v1/campaigns/triggers/delete?_id=${triggerId}`, {
      method: "POST",
      headers
    });
    return response.ok
  }

  const canCreateTrigger = () => {
    const { platform, selectedGoal, banners, triggerName, exclusions } = data.dynamicRetargeting
    const selectedConflictsWithExclusions =
      selectedGoal !== "all" &&
      exclusions.some((g) => String(g) === String(selectedGoal))
    return (
      data.dynamicRetargeting.enabled &&
      platform &&
      selectedGoal !== "all" &&
      !selectedConflictsWithExclusions &&
      banners.length > 0 &&
      triggerName.trim() &&
      triggerName.length <= 50
    )
  }

  const handleCreateTrigger = async () => {
    if (!canCreateTrigger()) return

    if (disable) {
      return enqueueSnackbar("Необходимо обновить дату окончания работы кампании.", { variant: "info" })
    }

    const { platform, selectedGoal, banners, triggerName } = data.dynamicRetargeting

    if (editingTriggerId) {
      setSavedTriggers((prev) =>
        prev.map((trigger) =>
          trigger.id === editingTriggerId
            ? {
                ...trigger,
                name: triggerName,
                platform,
                selectedGoal,
                banners,
                exclusions: data.dynamicRetargeting.exclusions || [],
              }
            : trigger,
        ),
      )
      const triggerResponse = await updateTrigger(editingTriggerId, {
        name: triggerName,
        platform,
        selectedGoal,
        banners,
        exclusions: data.dynamicRetargeting.exclusions || [],
      })
      if (triggerResponse) {
        enqueueSnackbar("Триггер успешно обновлен", { variant: "success" })
      } else {
        enqueueSnackbar("Произошла ошибка при обновлении триггера", { variant: "error" })
      }
      setEditingTriggerId(null)
    } else {
      const newTrigger = {
        id: Date.now(),
        name: triggerName,
        enabled: false,
        platform,
        selectedGoal,
        banners,
        exclusions: data.dynamicRetargeting.exclusions || [],
      }
      setSavedTriggers((prev) => [...prev, newTrigger])
      const triggerResponse = await createTrigger(newTrigger)
      if (triggerResponse) {
        enqueueSnackbar("Триггер успешно создан", { variant: "success" })
      } else {
        enqueueSnackbar("Произошла ошибка при создании триггера", { variant: "error" })
      }
    }

    setData((prev) => ({
      ...prev,
      dynamicRetargeting: {
        ...prev.dynamicRetargeting,
        platform: "ya_metrika",
        selectedGoal: "all",
        banners: [],
        triggerName: "",
        exclusions: [],
      },
    }))

    setUpdateTriggers((prev) => !prev)

    if (setHasUnsavedChanges) {
      setHasUnsavedChanges(true)
    }
  }

  const handleMetricaGoalToggle = (goalId) => {
    const idStr = String(goalId)
    const currentGoals = data.retargeting.ya_metrika_goals.map(String)
    const isSelected = currentGoals.includes(idStr)

    let newGoals
    if (isSelected) {
      newGoals = currentGoals.filter((id) => id !== idStr)
    } else {
      newGoals = [...currentGoals, idStr]
    }

    if (!isSelected && data.retargeting.retarget_all_visitors) {
      setData((prev) => ({
        ...prev,
        retargeting: {
          ...prev.retargeting,
          retarget_all_visitors: false,
          ya_metrika_goals: newGoals,
        },
      }))
      handleChange("retarget_all_visitors", false)
      handleChange("ya_metrika_goals", newGoals, 1800)
      return
    }

    handleInputChange("retargeting", "ya_metrika_goals", newGoals)
  }

  const handleAllVisitorsToggle = () => {
    if (disable) {
      return enqueueSnackbar("Необходимо обновить дату окончания работы кампании.", { variant: "info" })
    }

    const newValue = !data.retargeting.retarget_all_visitors

    setData((prev) => ({
      ...prev,
      retargeting: {
        ...prev.retargeting,
        retarget_all_visitors: newValue,
        ya_metrika_goals: newValue ? [] : prev.retargeting.ya_metrika_goals,
      },
    }))

    if (newValue) {
      setIsMetricaDropdownOpen(false)
      handleChange("ya_metrika_goals", [], 500)
    }
    handleChange("retarget_all_visitors", newValue, 500)
  }

  const getSelectedAds = () => {
    return ads.filter((ad) => data.dynamicRetargeting.banners.includes(ad.id))
  }

  const handleAdsToggle = (adId) => {
    const currentAds = data.dynamicRetargeting.banners
    const isSelected = currentAds.includes(adId)

    let newAds
    if (isSelected) {
      newAds = currentAds.filter((id) => id !== adId)
    } else {
      newAds = [...currentAds, adId]
    }

    handleInputChange("dynamicRetargeting", "banners", newAds)
  }

  const getSelectedMetricaGoals = () => {
    return metricaGoals.filter((goal) =>
      data.retargeting.ya_metrika_goals.includes(String(goal.ya_metrika_id)),
    )
  }

  const handleExclusionsToggle = (goalId) => {
    if (String(goalId) === String(data.dynamicRetargeting.selectedGoal)) {
      return
    }
    const current = data.dynamicRetargeting.exclusions
    const isSelected = current.includes(goalId)
    const newList = isSelected ? current.filter((id) => id !== goalId) : [...current, goalId]
    handleInputChange("dynamicRetargeting", "exclusions", newList)
  }

  const handleEditTrigger = (trigger) => {
    setEditingTriggerId(trigger.id)
    setData((prev) => ({
      ...prev,
      dynamicRetargeting: {
        ...prev.dynamicRetargeting,
        enabled: true,
        platform: trigger.platform,
        selectedGoal: trigger.selectedGoal,
        banners: trigger.banners,
        triggerName: trigger.name,
        exclusions:
          (trigger.exclusions || []).filter((g) => String(g) !== String(trigger.selectedGoal)),
      },
    }))
  }

  const handleDeleteTrigger = async (id) => {
    console.log("delete1", id)
    setSavedTriggers((prev) => prev.filter((trigger) => trigger.id !== id))
    if (editingTriggerId === id) {
      console.log("delete2", id)
      setEditingTriggerId(null)
      setData((prev) => ({
        ...prev,
        dynamicRetargeting: {
          ...prev.dynamicRetargeting,
          platform: "ya_metrika",
          selectedGoal: "all",
          banners: [],
          triggerName: "",
          exclusions: [],
        },
      }))
    }
    const triggerResponse = await deleteTrigger(id)
    if (triggerResponse) {
      enqueueSnackbar("Триггер успешно удален", { variant: "success" })
    } else {
      enqueueSnackbar("Произошла ошибка при удалении триггера", { variant: "error" })
    }
    setOpenDropdown(false)
    setUpdateTriggers((prev) => !prev)
    if (setHasUnsavedChanges) {
      setHasUnsavedChanges(true)
    }
  }

  useEffect(() => {
    const handleClickOutside = () => {
      setOpenDropdown(false)
      setIsMetricaDropdownOpen(false)
      setIsAdsDropdownOpen(false)
      setIsExclusionsDropdownOpen(false)
    }
    document.addEventListener("click", handleClickOutside)
    return () => document.removeEventListener("click", handleClickOutside)
  }, [])

  const styles = {
    container: {
      marginLeft: window.outerWidth > 1000 ? "20px" : "20px",
      marginTop: window.outerWidth < 768 ? "40px" : "0",
      width: window.outerWidth < 375 ? "288px" : window.outerWidth < 768 ? "343px" : "auto",
      fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    },
    title: {
      marginBottom: "10px",
      fontSize: "16px",
      fontWeight: "600",
      color: "#1a1a1a",
    },
    infoNotification: {
      backgroundColor: "#eff6ff",
      border: "1px solid #bfdbfe",
      borderRadius: "8px",
      padding: "12px 16px",
      marginBottom: "24px",
      boxShadow: "0 1px 3px rgba(0, 0, 0, 0.05)",
    },
    infoNotificationContent: {
      display: "flex",
      alignItems: "center",
      gap: "12px",
    },
    infoIcon: {
      fontSize: "18px",
      flexShrink: 0,
    },
    infoText: {
      fontSize: "14px",
      color: "#1e40af",
      lineHeight: "1.5",
    },
    grid: {
      display: "grid",
      gridTemplateColumns: window.outerWidth > 1200 ? "1fr 1fr 1fr" : window.outerWidth > 768 ? "1fr 1fr" : "1fr",
      gap: "24px",
      marginBottom: "24px",
    },
    card: {
      backgroundColor: "#ffffff",
      border: "1px solid #e5e7eb",
      borderRadius: "8px",
      padding: "20px",
      boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
    },
    cardTitle: {
      fontSize: "16px",
      fontWeight: "500",
      color: "#1f2937",
    },
    select: {
      width: "100%",
      padding: "8px 12px",
      border: "1px solid #d1d5db",
      borderRadius: "6px",
      fontSize: "14px",
      marginBottom: "12px",
      backgroundColor: "#ffffff",
    },
    multiSelectContainer: {
      position: "relative",
      marginBottom: "12px",
    },
    multiSelectTrigger: {
      width: "100%",
      padding: "8px 12px",
      border: "1px solid #d1d5db",
      borderRadius: "6px",
      fontSize: "14px",
      backgroundColor: "#ffffff",
      cursor: "pointer",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      minHeight: "40px",
    },
    multiSelectDropdown: {
      position: "absolute",
      top: "100%",
      left: "0",
      right: "0",
      backgroundColor: "#ffffff",
      border: "1px solid #d1d5db",
      borderRadius: "6px",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
      zIndex: 10,
      maxHeight: "200px",
      overflowY: "auto",
    },
    multiSelectOption: {
      padding: "8px 12px",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      gap: "8px",
      fontSize: "14px",
    },
    checkbox: {
      minWidth: "16px",
      minHeight: "16px",
      maxWidth: "16px",
      maxHeight: "16px",
      border: "1px solid #d1d5db",
      borderRadius: "3px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "#ffffff",
    },
    checkboxChecked: {
      backgroundColor: "#3b82f6",
      borderColor: "#3b82f6",
      color: "#ffffff",
    },
    selectedGoalsContainer: {
      display: "flex",
      flexWrap: "wrap",
      gap: "6px",
      marginBottom: "8px",
    },
    selectedGoalTag: {
      backgroundColor: "#eff6ff",
      border: "1px solid #bfdbfe",
      borderRadius: "4px",
      padding: "4px 8px",
      fontSize: "12px",
      display: "flex",
      alignItems: "center",
      gap: "4px",
      color: "#1e40af",
    },
    removeGoalButton: {
      background: "none",
      border: "none",
      color: "#6b7280",
      cursor: "pointer",
      fontSize: "14px",
      padding: "0",
      width: "16px",
      height: "16px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: "50%",
    },
    input: {
      width: "100%",
      padding: "8px 12px",
      border: "1px solid #d1d5db",
      borderRadius: "6px",
      fontSize: "14px",
      backgroundColor: "#ffffff",
    },
    button: {
      padding: "8px 16px",
      backgroundColor: "#3b82f6",
      color: "#ffffff",
      border: "none",
      borderRadius: "6px",
      fontSize: "14px",
      fontWeight: "500",
      cursor: "pointer",
      marginTop: "12px",
      width: "100%",
    },
    buttonDisabled: {
      backgroundColor: "#d1d5db",
      cursor: "not-allowed",
    },
    switchContainer: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "12px",
    },
    switch: {
      position: "relative",
      width: "44px",
      height: "24px",
      backgroundColor: "#e5e7eb",
      borderRadius: "12px",
      cursor: "pointer",
      transition: "background-color 0.2s",
    },
    switchActive: {
      backgroundColor: "#3b82f6",
    },
    switchThumb: {
      position: "absolute",
      top: "2px",
      left: "2px",
      width: "20px",
      height: "20px",
      backgroundColor: "#ffffff",
      borderRadius: "50%",
      transition: "transform 0.2s",
      boxShadow: "0 1px 3px rgba(0, 0, 0, 0.3)",
    },
    switchThumbActive: {
      transform: "translateX(20px)",
    },
    sliderContainer: {
      marginBottom: "16px",
    },
    sliderLabel: {
      display: "flex",
      justifyContent: "space-between",
      marginBottom: "8px",
      fontSize: "14px",
    },
    slider: {
      width: "100%",
      height: "6px",
      borderRadius: "3px",
      padding: 0,
      background: "#e5e7eb",
      outline: "none",
      appearance: "none",
      cursor: "pointer",
    },
    chartContainer: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      padding: "10px 0",
    },
    chart: {
      width: "120px",
      height: "120px",
      borderRadius: "50%",
      position: "relative",
      marginBottom: "16px",
    },
    chartCenter: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: "85px",
      height: "85px",
      backgroundColor: "#ffffff",
      borderRadius: "50%",
    },
    legend: {
      display: "flex",
      flexDirection: "column",
      gap: "8px",
    },
    legendItem: {
      display: "flex",
      alignItems: "center",
      gap: "8px",
      fontSize: "14px",
    },
    legendColor: {
      width: "16px",
      height: "16px",
      borderRadius: "2px",
    },
    tooltip: {
      position: "relative",
      display: "inline-block",
      marginLeft: "8px",
    },
    tooltipText: {
      visibility: "hidden",
      width: "200px",
      backgroundColor: "#1f2937",
      color: "#ffffff",
      textAlign: "center",
      borderRadius: "6px",
      padding: "8px",
      position: "absolute",
      zIndex: 1,
      bottom: "125%",
      left: "50%",
      marginLeft: "-100px",
      fontSize: "12px",
      lineHeight: "1.4",
    },
    helpIcon: {
      width: "16px",
      height: "16px",
      borderRadius: "50%",
      backgroundColor: "#e5e7eb",
      color: "#6b7280",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "12px",
      cursor: "help",
    },
    triggerItem: {
      borderTop: "1.5px solid #e5e7eb",
      paddingTop: "15px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    triggerActions: {
      display: "flex",
      alignItems: "center",
      gap: "12px",
    },
    iconButton: {
      width: "24px",
      height: "24px",
      border: "none",
      background: "none",
      cursor: "pointer",
      borderRadius: "4px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "#000",
      position: "relative",
      fontSize: "20px",
    },
    dropdown: {
      position: "absolute",
      top: "100%",
      right: "10",
      backgroundColor: "#ffffff",
      border: "1px solid #e5e7eb",
      borderRadius: "6px",
      boxShadow: "0 0 10px 1px rgba(0, 0, 0, 0.2)",
      zIndex: 10,
      minWidth: "100px",
    },
    dropdownItem: {
      padding: "6px 10px",
      cursor: "pointer",
      fontSize: "14px",
      color: "#ef4444",
      borderRadius: "4px",
      margin: "4px",
    },
    disabled: {
      opacity: 0.5,
      pointerEvents: "none",
    },
  }

  const retargetingPercentage = (data.budgetDistribution.retargeting / 100) * 360
  const lookAlikePercentage = (data.budgetDistribution.lookAlike / 100) * 360
  const selectedMetricaGoals = getSelectedMetricaGoals()
  const selectedAds = getSelectedAds()
  const canProceed = data.retargeting.retarget_all_visitors || data.retargeting.ya_metrika_goals.length > 0


  return (
    <div style={styles.container}>
      <div style={styles.title}>
        <h2>Ретаргетинг</h2>
      </div>

      <div style={styles.infoNotification}>
        <div style={styles.infoNotificationContent}>
          <span style={styles.infoIcon}>ℹ️</span>
          <span style={styles.infoText}>
            Выберите цели из Я. Метрики или включите возврат всех посетителей сайта
          </span>
        </div>
      </div>

      <div style={styles.grid}>
        {/* Цели ретаргетинга и Частотность размещения */}
        <div>
          {/* Цели ретаргетинга */}
          <div style={styles.card}>
            <h3 style={{...styles.cardTitle, marginBottom: "16px" }}>Цели ретаргетинга</h3>

            <div
              style={{
                ...styles.multiSelectOption,
                marginBottom: "12px",
                padding: "10px 12px",
                border: "1px solid #e5e7eb",
                borderRadius: "8px",
                cursor: disable ? "not-allowed" : "pointer",
                opacity: disable ? 0.5 : 1,
              }}
              onClick={handleAllVisitorsToggle}
              onMouseEnter={(e) => {
                if (!disable) e.currentTarget.style.backgroundColor = "#f9fafb"
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "transparent"
              }}
            >
              <div
                style={{
                  ...styles.checkbox,
                  ...(data.retargeting.retarget_all_visitors ? styles.checkboxChecked : {}),
                }}
              >
                {data.retargeting.retarget_all_visitors && "✓"}
              </div>
              <span style={{ fontWeight: "500", fontSize: "14px" }}>Возврат всех посетителей сайта</span>
            </div>

            <div style={styles.multiSelectContainer}>
              <div
                style={{
                  ...styles.multiSelectTrigger,
                  ...(data.retargeting.retarget_all_visitors ? { opacity: 0.5, cursor: "not-allowed" } : {}),
                }}
                onClick={(e) => {
                  e.stopPropagation()
                  if (data.retargeting.retarget_all_visitors) return
                  if (disable) {
                    return enqueueSnackbar("Необходимо обновить дату окончания работы кампании.", { variant: "info" })
                  }
                  setIsMetricaDropdownOpen(!isMetricaDropdownOpen)
                }}
              >
                <span style={{ color: selectedMetricaGoals.length > 0 ? "#1f2937" : "#9ca3af" }}>
                  {selectedMetricaGoals.length > 0
                    ? `Выбрано целей: ${selectedMetricaGoals.length}`
                    : "Выбрать из Я.Метрики"}
                </span>
                <span
                  style={{
                    transform: isMetricaDropdownOpen ? "rotate(180deg)" : "rotate(0deg)",
                    transition: "transform 0.2s",
                  }}
                >
                  ▼
                </span>
              </div>

              {isMetricaDropdownOpen && !data.retargeting.retarget_all_visitors && (
                <div style={styles.multiSelectDropdown}>
                  {metricaGoals.map((goal) => {
                    const isSelected = data.retargeting.ya_metrika_goals.includes(String(goal.ya_metrika_id))
                    return (
                      <div
                        key={goal.ya_metrika_id}
                        style={styles.multiSelectOption}
                        onClick={(e) => {
                          e.stopPropagation()
                          handleMetricaGoalToggle(goal.ya_metrika_id)
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.backgroundColor = "#f9fafb"
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.backgroundColor = "transparent"
                        }}
                      >
                        <div
                          style={{
                            ...styles.checkbox,
                            ...(isSelected ? styles.checkboxChecked : {}),
                          }}
                        >
                          {isSelected && "✓"}
                        </div>
                        <div>
                          <div style={{ fontWeight: "500" }}>{goal.name}</div>
                          <div style={{ fontSize: "12px", color: "#6b7280" }}>{goal.ya_metrika_id}</div>
                        </div>
                      </div>
                    )
                  })}
                </div>
              )}
            </div>

            <select
              disabled
              style={{...styles.select, cursor: "not-allowed" }}
              value={data.retargetingGoals.crmSystem}
              onChange={(e) => handleInputChange("retargetingGoals", "crmSystem", e.target.value)}
            >
              <option disabled hidden value="">Выбрать из CRM-системы</option>
              <option value="crm1">Цель 1 из CRM</option>
              <option value="crm2">Цель 2 из CRM</option>
            </select>
          </div>

          {/* Частотность размещения */}
          <div style={{ ...styles.card, marginTop: "24px" }}>
            <div
              style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "8px" }}
            >
              <h3 style={{ ...styles.cardTitle, marginBottom: 0 }}>Частотность размещения</h3>
              <div style={{ display: "flex", alignItems: "center" }}>
                <div
                  style={styles.tooltip}
                  onMouseEnter={(e) => {
                    const tooltip = e.currentTarget.querySelector(".tooltip-text-frequency")
                    if (tooltip) tooltip.style.visibility = "visible"
                  }}
                  onMouseLeave={(e) => {
                    const tooltip = e.currentTarget.querySelector(".tooltip-text-frequency")
                    if (tooltip) tooltip.style.visibility = "hidden"
                  }}
                >
                  <div style={styles.helpIcon}>?</div>
                  <div className="tooltip-text-frequency" style={styles.tooltipText}>
                    Частота показа объявления одному пользователю в сутки
                  </div>
                </div>
              </div>
            </div>
            <div style={{ fontSize: "12px", fontWeight: "normal", color: "#6b7280", marginTop: "4px", marginBottom: "8px" }}>
              Частота показа
            </div>
            <select
              style={styles.select}
              value={data.placementFrequency.frequency}
              disabled={disable}
              onChange={(e) => handleInputChange("placementFrequency", "frequency", e.target.value)}
            >
              <option disabled hidden value="">Выбрать значение</option>
              <option value="-1">
                Без ограничений
              </option>
              <option value="1">1</option>
              <option value="4">4</option>
              <option value="8">8</option>
              <option value="16">16</option>
              <option value="32">32</option>
              <option value="custom">Ввести своё число</option>
            </select>
            {data.placementFrequency.frequency === "custom" && (
              <input
                type="text"
                disabled={disable}
                style={styles.input}
                placeholder="Ввести значение"
                value={data.placementFrequency.customValueFrequency}
                onChange={(e) => {e.target.value = e.target.value.replace(/[^0-9]/g, ''); handleInputChange("placementFrequency", "customValueFrequency", e.target.value); 
                }}
              />
            )}

            <div style={{ fontSize: "12px", color: "#6b7280", margin: "15px 0 8px" }}>Интервал показов</div>
            <select
              style={styles.select}
              value={data.placementFrequency.intervalMinutes}
              disabled={disable}
              onChange={(e) => handleInputChange("placementFrequency", "intervalMinutes", e.target.value)}
            >
              <option disabled hidden value="">Выбрать значение</option>
              <option value="5">5 минут</option>
              <option value="15">15 минут</option>
              <option value="30">30 минут</option>
              <option value="60">60 минут</option>
              <option value="120">120 минут</option>
              <option value="custom">Ввести своё число</option>
            </select>
            {data.placementFrequency.intervalMinutes === "custom" && (
              <input
                type="text"
                disabled={disable}
                style={styles.input}
                placeholder="Ввести значение"
                value={data.placementFrequency.customValueIntervalMinutes}
                onChange={(e) => {e.target.value = e.target.value.replace(/[^0-9]/g, ''); handleInputChange("placementFrequency", "customValueIntervalMinutes", e.target.value)}}
              />
            )}
          </div>

          <div style={{ ...styles.card, marginTop: "24px" }}>
            <h3 style={{...styles.cardTitle, marginBottom: "8px"}}>Количество посетителей за 30 дней</h3>
            <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
              <div>
                <div style={{ fontSize: "14px", color: "#6b7280", marginBottom: "4px" }}>Посетителей:</div>
                <div style={{ fontSize: "18px", fontWeight: "600", color: "#1f2937" }}>
                  {usersStats.users.toLocaleString("ru-RU")}
                </div>
              </div>
              <div>
                <div style={{ fontSize: "14px", color: "#6b7280", marginBottom: "4px" }}>Доля новых посетителей:</div>
                <div style={{ fontSize: "18px", fontWeight: "600", color: "#1f2937" }}>
                  {usersStats.newUsersPercentage.toLocaleString("ru-RU")}%
                </div>
              </div>
            </div>
          </div>

        </div>

        {/* Использование SSP и Распределение бюджета */}
        <div>
          {/* Использование SSP */}
          <div style={styles.card}>
            <h3 style={{...styles.cardTitle, marginBottom: "8px"}}>Использование SSP</h3>

            {getDomainConfig().brand === 'retargeo' && (
              <div style={styles.switchContainer}>
                <span>Retargeo</span>
                <div
                  style={{
                    ...styles.switch,
                    ...(data.retargeting.using_retargeo ? styles.switchActive : {}),
                  }}
                  onClick={() => {
                    if (disable) {
                      return enqueueSnackbar("Необходимо обновить дату окончания работы кампании.", { variant: "info" })
                    }
                    handleSspToggle("using_retargeo")
                  }}
                >
                  <div
                    style={{
                      ...styles.switchThumb,
                      ...(data.retargeting.using_retargeo ? styles.switchThumbActive : {}),
                    }}
                  ></div>
                </div>
              </div>
            )}
            {getDomainConfig().brand === 'programmatic' && (
              <div style={styles.switchContainer}>
                <span>Programmatic.ru</span>
                <div
                  style={{
                    ...styles.switch,
                    ...(data.retargeting.using_programmatic ? styles.switchActive : {}),
                  }}
                  onClick={() => {
                    if (disable) {
                      return enqueueSnackbar("Необходимо обновить дату окончания работы кампании.", { variant: "info" })
                    }
                    handleSspToggle("using_programmatic")
                  }}
                >
                  <div
                    style={{
                      ...styles.switchThumb,
                      ...(data.retargeting.using_programmatic ? styles.switchThumbActive : {}),
                    }}
                  ></div>
                </div>
              </div>
            )}
            <div style={styles.switchContainer}>
              <span>РСЯ</span>
              <div
                style={{
                  ...styles.switch,
                  ...(data.retargeting.using_rsya ? styles.switchActive : {}),
                }}
                onClick={() => {
                  if (disable) {
                    return enqueueSnackbar("Необходимо обновить дату окончания работы кампании.", { variant: "info" })
                  }
                  handleSspToggle("using_rsya")
                }}
              >
                <div
                  style={{
                    ...styles.switchThumb,
                    ...(data.retargeting.using_rsya ? styles.switchThumbActive : {}),
                  }}
                ></div>
              </div>
            </div>
          </div>

          {/* Распределение бюджета */}
          <div style={{ ...styles.card, marginTop: "24px" }}>
            <h3 style={{...styles.cardTitle, marginBottom: "8px"}}>Распределение Бюджета</h3>

            <div style={styles.sliderContainer}>
              <div style={styles.sliderLabel}>
                <span>Ретаргетинг</span>
                <span style={{ fontWeight: "500" }}>{data.budgetDistribution.retargeting}%</span>
              </div>
              <input
                disabled={disable}
                type="range"
                min="0"
                max="100"
                value={data.budgetDistribution.retargeting}
                onChange={(e) => handleBudgetChange("retargeting", e.target.value)}
                style={{
                  ...styles.slider,
                  background: `linear-gradient(to right, #3b82f6 0%, #3b82f6 ${data.budgetDistribution.retargeting}%, #e5e7eb ${data.budgetDistribution.retargeting}%, #e5e7eb 100%)`,
                }}
              />
            </div>

            <div style={styles.sliderContainer}>
              <div style={styles.sliderLabel}>
                <span>Look-a-like</span>
                <span style={{ fontWeight: "500" }}>{data.budgetDistribution.lookAlike}%</span>
              </div>
              <input
                disabled={disable}
                type="range"
                min="0"
                max="100"
                value={data.budgetDistribution.lookAlike}
                onChange={(e) => handleBudgetChange("lookAlike", e.target.value)}
                style={{
                  ...styles.slider,
                  background: `linear-gradient(to right, #8b5cf6 0%, #8b5cf6 ${data.budgetDistribution.lookAlike}%, #e5e7eb ${data.budgetDistribution.lookAlike}%, #e5e7eb 100%)`,
                }}
              />
            </div>
            <button
              style={{
                ...styles.button
              }}
              onClick={handleSaveBudgetDistribution}
            >
              Сохранить
            </button>
          </div>

          {/* Диаграмма распределения бюджета
          <div style={{ ...styles.card, marginTop: "24px" }}>
            <h3 style={{...styles.cardTitle, marginBottom: "7px"}}>Диаграмма распределения Бюджета</h3>
            <div style={styles.chartContainer}>
              <div
                style={{
                  ...styles.chart,
                  background: `conic-gradient(#3b82f6 0deg ${retargetingPercentage}deg, #8b5cf6 ${retargetingPercentage}deg 360deg)`,
                }}
              >
                <div style={styles.chartCenter}></div>
              </div>
              <div style={styles.legend}>
                <div style={styles.legendItem}>
                  <div style={{ ...styles.legendColor, backgroundColor: "#3b82f6" }}></div>
                  <span>Ретаргетинг ({data.budgetDistribution.retargeting}%)</span>
                </div>
                <div style={styles.legendItem}>
                  <div style={{ ...styles.legendColor, backgroundColor: "#8b5cf6" }}></div>
                  <span>Look-a-like ({data.budgetDistribution.lookAlike}%)</span>
                </div>
              </div>
            </div>
          </div> */}
        </div>

        {/* Динамический ретаргетинг и Сохраненные триггеры */}
        <div>
          {/* Динамический ретаргетинг */}
          <div style={styles.card}>
            <div
              style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px" }}
            >
              <h3 style={{ ...styles.cardTitle, marginBottom: 0 }}>Динамический ретаргетинг</h3>
              <div style={{ display: "flex", alignItems: "center" }}>
                <div
                  style={{
                    ...styles.switch,
                    ...(data.dynamicRetargeting.enabled ? styles.switchActive : {}),
                  }}
                  onClick={handleDynamicRetargetingToggle}
                >
                  <div
                    style={{
                      ...styles.switchThumb,
                      ...(data.dynamicRetargeting.enabled ? styles.switchThumbActive : {}),
                    }}
                  ></div>
                </div>
                <div
                  style={styles.tooltip}
                  onMouseEnter={(e) => {
                    const tooltip = e.currentTarget.querySelector(".tooltip-text")
                    if (tooltip) tooltip.style.visibility = "visible"
                  }}
                  onMouseLeave={(e) => {
                    const tooltip = e.currentTarget.querySelector(".tooltip-text")
                    if (tooltip) tooltip.style.visibility = "hidden"
                  }}
                >
                  <div style={styles.helpIcon}>?</div>
                  <div className="tooltip-text" style={styles.tooltipText}>
                    Мы рекомендуем подключать динамический ретаргетинг через 2 недели после старта работы классического
                    ретаргетинга
                  </div>
                </div>
              </div>
            </div>
            
            <div style={data.dynamicRetargeting.enabled ? {} : styles.disabled}>
              <div style={{ fontSize: "12px", fontWeight: "normal", color: "#6b7280", marginTop: "4px", marginBottom: "8px" }}>
                Выбор площадки
              </div>
              <select
                style={styles.select}
                value={data.dynamicRetargeting.platform}
                onChange={(e) => handleInputChange("dynamicRetargeting", "platform", e.target.value)}
                disabled={!data.dynamicRetargeting.enabled}
              >
                <option value="ya_metrika">Я.Метрика</option>
                <option disabled value="crm">CRM-системы</option>
              </select>
              
              <div style={{ fontSize: "12px", fontWeight: "normal", color: "#6b7280", marginTop: "4px", marginBottom: "8px" }}>
                Выполненная ранее цель
              </div>
              <select
                style={styles.select}
                value={data.dynamicRetargeting.selectedGoal}
                onChange={(e) => handleInputChange("dynamicRetargeting", "selectedGoal", e.target.value)}
                disabled={!data.dynamicRetargeting.enabled}
              >
                <option disabled hidden value="">+ Выбранная цель</option>
                <option value="all">Любая цель</option>
                {metricaGoals
                  .filter((goal) =>
                    data.retargeting.ya_metrika_goals.includes(String(goal.ya_metrika_id)),
                  )
                  .map((goal) => {
                  return (
                  <option key={goal.ya_metrika_id} value={goal.ya_metrika_id}>{goal.name}</option>
                )})}
              </select>

              <div style={{ fontSize: "12px", fontWeight: "normal", color: "#6b7280", marginTop: "12px", marginBottom: "8px" }}>
                Список целей исключений
              </div>
              <div style={styles.multiSelectContainer}>
                <div
                  style={styles.multiSelectTrigger}
                  onClick={(e) => {
                    e.stopPropagation()
                    if (!data.dynamicRetargeting.enabled) return
                    if (disable) {
                      return enqueueSnackbar("Необходимо обновить дату окончания работы кампании.", { variant: "info" })
                    }
                    setIsExclusionsDropdownOpen((prev) => !prev)
                  }}
                >
                  <span style={{ color: "#1f2937" }}>
                    {data.dynamicRetargeting.exclusions.length > 0
                      ? `Выбрано исключений: ${data.dynamicRetargeting.exclusions.length}`
                      : "Выбрать цели для исключения"}
                  </span>
                  <span
                    style={{
                      transform: isExclusionsDropdownOpen ? "rotate(180deg)" : "rotate(0deg)",
                      transition: "transform 0.2s",
                    }}
                  >
                    ▼
                  </span>
                </div>

                {isExclusionsDropdownOpen && (
                  <div style={styles.multiSelectDropdown}>
                    {metricaGoals.map((goal) => {
                      const isSelected = data.dynamicRetargeting.exclusions.includes(goal.ya_metrika_id)
                      const isDisabled = String(goal.ya_metrika_id) === String(data.dynamicRetargeting.selectedGoal)
                      return (
                        <div
                          key={goal.ya_metrika_id}
                          style={{ 
                            ...styles.multiSelectOption, 
                            ...(isDisabled ? { opacity: 0.5, pointerEvents: "none" } : {}) 
                          }}
                          onClick={(e) => {
                            e.stopPropagation()
                            handleExclusionsToggle(goal.ya_metrika_id)
                          }}
                          onMouseEnter={(e) => {
                            e.target.style.backgroundColor = "#f9fafb"
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.backgroundColor = "transparent"
                          }}
                        >
                          <div
                            style={{
                              ...styles.checkbox,
                              ...(isSelected ? styles.checkboxChecked : {}),
                            }}
                          >
                            {isSelected && "✓"}
                          </div>
                          <div>
                            <div style={{ fontWeight: "500" }}>{goal.name}</div>
                            <div style={{ fontSize: "12px", color: "#6b7280" }}>{goal.ya_metrika_id}</div>
                          </div>
                        </div>
                      )
                    })}
                  </div>
                )}
              </div>

              <div style={{ fontSize: "12px", fontWeight: "normal", color: "#6b7280", marginTop: "4px", marginBottom: "8px" }}>
                Выбранные Объявления
              </div>
              {/* <select
                style={styles.select}
                value={data.dynamicRetargeting.banners}
                onChange={(e) => handleInputChange("dynamicRetargeting", "banners", e.target.value)}
                disabled={!data.dynamicRetargeting.enabled}
              >
                <option disabled hidden value="">+ Объявление</option>
                <option value="all">Все объявления</option>
                {ads.map((ad) => (
                  <option key={ad.id} value={ad.id}>{ad.head}</option>
                ))}
              </select> */}
              <div style={styles.multiSelectContainer}>
                <div
                  style={styles.multiSelectTrigger}
                  onClick={(e) => {
                    e.stopPropagation()
                    if (disable) {
                      return enqueueSnackbar("Необходимо обновить дату окончания работы кампании.", { variant: "info" })
                    }
                    setIsAdsDropdownOpen((prev) => !prev)
                  }}
                >
                  <span style={{ color: "#1f2937" }}>
                    {selectedAds.length > 0
                      ? `Выбрано объявлений: ${selectedAds.length}`
                      : "Выбрать объявления"}
                  </span>
                  <span
                    style={{
                      transform: isAdsDropdownOpen ? "rotate(180deg)" : "rotate(0deg)",
                      transition: "transform 0.2s",
                    }}
                  >
                    ▼
                  </span>
                </div>

                {isAdsDropdownOpen && (
                  <div style={styles.multiSelectDropdown}>
                    {ads.map((ad) => {
                      const isSelected = data.dynamicRetargeting.banners.includes(ad.id)
                      return (
                        <div
                          key={ad.id}
                          style={styles.multiSelectOption}
                          onClick={(e) => {
                            e.stopPropagation()
                            handleAdsToggle(ad.id)
                          }}
                          onMouseEnter={(e) => {
                            e.target.style.backgroundColor = "#f9fafb"
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.backgroundColor = "transparent"
                          }}
                        >
                          <div
                            style={{
                              ...styles.checkbox,
                              ...(isSelected ? styles.checkboxChecked : {}),
                            }}
                          >
                            {isSelected && "✓"}
                          </div>
                          <div style={{ display: "flex", gap: "10px", marginLeft: "10px", alignItems: "center" }}>
                            {ad.banners.length !== 0 && (
                              ad.banners[0].extension && ad.banners[0].extension.toLowerCase() === "mp4" ? (
                                <video
                                  style={{
                                    width: "40px",
                                    height: "40px",
                                    objectFit: "fill",
                                  }}
                                  src={ad.banners[0].url}
                                  muted
                                  controls
                                />
                              ) : (
                                <img
                                  style={{
                                    width: "40px",
                                    height: "40px",
                                    objectFit: "fill",
                                  }}
                                  src={ad.banners[0].url}
                                  alt="banner"
                                />
                              )
                            )}
                            <div style={{ fontWeight: "500" }}>{ad.head}</div>
                          </div>
                        </div>
                      )
                    })}
                  </div>
                )}
              </div>
              <div style={{ fontSize: "12px", fontWeight: "normal", color: "#6b7280", marginTop: "4px", marginBottom: "8px" }}>
                Наименование триггера
              </div>
              <input
                type="text"
                style={styles.input}
                placeholder="Триггер 1"
                value={data.dynamicRetargeting.triggerName}
                onChange={(e) => {
                  if (e.target.value.length <= 50) {
                    handleInputChange("dynamicRetargeting", "triggerName", e.target.value)
                  }
                }}
                disabled={!data.dynamicRetargeting.enabled}
                maxLength={50}
              />

              {
                <button
                  style={{
                    ...styles.button,
                    ...(canCreateTrigger() ? {} : styles.buttonDisabled),
                  }}
                  onClick={handleCreateTrigger}
                  disabled={!canCreateTrigger()}
                >
                  {editingTriggerId ? "Сохранить триггер" : "Создать триггер"}
                </button>
              }
            </div>
          </div>

          {/* Сохраненные триггеры */}
          <div style={{ ...styles.card, marginTop: "24px" }}>
            <h3 style={styles.cardTitle}>Сохраненные триггеры</h3>

            {savedTriggers.length === 0 ? (
              <div style={{ fontSize: "13px", fontWeight: "normal", color: "#6b7280", marginTop: "4px" }}>
                У вас нет сохраненных триггеров
              </div>
            ) : (
              <div style={{ display: "flex", flexDirection: "column", gap: "15px", marginTop: "16px", opacity: data.dynamicRetargeting.enabled ? 1 : 0.5 }}>
                {savedTriggers.map((trigger) => (
                  <div key={trigger.id} style={styles.triggerItem}>
                    <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                      <span style={{ width: "8px", height: "8px", borderRadius: "50%", backgroundColor: trigger.enabled ? "#50e750" : "#c4c4c4" }}></span>
                      <span style={{ color: editingTriggerId === trigger.id ? "#3b82f6" : "inherit" }}>{trigger.name}</span>
                    </div>

                    <div style={styles.triggerActions}>
                      <div
                        style={{
                          ...styles.switch,
                          ...(trigger.enabled ? styles.switchActive : {}),
                        }}
                        onClick={() => {
                          if (!data.dynamicRetargeting.enabled) return
                          handleTriggerToggle(trigger.id)
                        }}
                      >
                        <div
                          style={{
                            ...styles.switchThumb,
                            ...(trigger.enabled ? styles.switchThumbActive : {}),
                          }}
                        ></div>
                      </div>
                      <button style={styles.iconButton} title="Редактировать" onClick={() => { if (!data.dynamicRetargeting.enabled) return; handleEditTrigger(trigger)}}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-square-pen-icon lucide-square-pen"><path d="M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.375 2.625a1 1 0 0 1 3 3l-9.013 9.014a2 2 0 0 1-.853.505l-2.873.84a.5.5 0 0 1-.62-.62l.84-2.873a2 2 0 0 1 .506-.852z"/></svg>
                      </button>
                      <button
                        style={styles.iconButton}
                        title="Еще действия"
                        onClick={(e) => {
                          e.stopPropagation()
                          if (!data.dynamicRetargeting.enabled) return
                          setOpenDropdown(openDropdown === trigger.id ? null : trigger.id)
                        }}
                      >
                        ⋯
                        {openDropdown === trigger.id && (
                          <div style={styles.dropdown}>
                            <div
                              style={styles.dropdownItem}
                              onClick={(e) => {
                                e.stopPropagation()
                                handleDeleteTrigger(trigger.id)
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor = "#fef2f2"
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = "transparent"
                              }}
                            >
                              Удалить
                            </div>
                          </div>
                        )}
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>

      <style jsx>{`
        input[type="range"]::-webkit-slider-thumb {
          appearance: none;
          width: 20px;
          height: 20px;
          border-radius: 50%;
          background: #3b82f6;
          cursor: pointer;
          border: 2px solid #ffffff;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
        }
        
        input[type="range"]::-moz-range-thumb {
          width: 20px;
          height: 20px;
          border-radius: 50%;
          background: #3b82f6;
          cursor: pointer;
          border: 2px solid #ffffff;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
        }

        .tooltip-text {
          visibility: hidden;
        }

        select:focus, input:focus {
          outline: none;
          border-color: #3b82f6;
          box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
        }

        button:disabled:hover {
          background-color: #d1d5db;
        }
      `}</style>

      <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "32px" }}>
        <LoadingButton
          loadingPosition="end"
          variant="contained"
          disabled={!canProceed}
          sx={{
            marginLeft: "32px",
          }}
          onClick={() => {
            if (!canProceed) {
              return enqueueSnackbar("Выберите цели ретаргетинга или включите возврат всех посетителей сайта", { variant: "warning" })
            }
            trackWizardEvent("wizard_tab_retargeting", campaignID);
            changeTab("event", "5")
          }}
          endIcon={<SendIcon />}
        >
          Далее
        </LoadingButton>
      </div>
    </div>
  )
}
